<script>
import Vue from 'vue'
import Auditor from '@/components/Roles/Auditor/Newsfeed'
import Jefe from '@/components/Roles/Jefe/Newsfeed'
import Mantenimiento from '@/components/Roles/Mantenimiento/Newsfeed'

export default {
  functional: true,
  render: function (createElement, context) {
    const user = Vue.prototype.$user.data
    let element = null

    switch (user.roleCode) {
      case 'auditor':
        element = Auditor
        break

      case 'jefe':
        element = Jefe
        break

      case 'mantenimiento':
        element = Mantenimiento
        break

      default:
        // statements_def
        break
    }

    return createElement(element)
  }
}
</script>



// WEBPACK FOOTER //
// Newsfeed.vue?66a36d32